import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormArray,
  Validators,
  FormControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { RptFillAlllDDlserviceService } from "src/app/Shared/Services/rpt-fill-alll-ddlservice.service";
import { ToastrService } from "ngx-toastr";
import * as Global from "../../../Shared/Model/CommanHttp";

declare var $: any;
@Component({
  selector: "app-rpt-auction-refundlist",
  templateUrl: "./rpt-auction-refundlist.component.html",
  styleUrls: ["./rpt-auction-refundlist.component.css"],
})
export class RptAuctionRefundlistComponent implements OnInit {
  FrmRptAuction: FormGroup;
  loginlist: any = [];
  ddlAuctionTypeList: any = [];
  ddlAuctionNoList: any = [];
  _filterAuctionList: any = [];
  ddlOfficerList: any = [];
  FromDate: any;
  ToDate: any;
  ddlZoneList: any = [];
  editedSearch: boolean;
  constructor(
    private fb: FormBuilder,
    private MsgService: ToastrService,
    private router: Router,
    private RptFillAlllDDlService: RptFillAlllDDlserviceService
  ) {
    this.CreateFrmRptAuction();
    this.editedSearch = true;
  }
  CreateFrmRptAuction() {
    this.FrmRptAuction = this.fb.group({
      ddlAuctionType: ["0"],
      ddlAuctionNo: [""],
      ddlStatus: ["2"],
      ddlZone: ["0"],
      txtDateFrom: ["", [Validators.maxLength(10), Validators.minLength(10)]],
      txtDateTo: ["", [Validators.maxLength(10), Validators.minLength(10)]],
      winList: true,
    });
  }
  ngOnInit() {
    this.FillAllDDL();
  }
  FillAllDDL() {
    let Ind = 1;
    let ResponseDecrpt = sessionStorage.getItem("loginSession");
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let OrgCode = loginlist[0]["OrgCode"];
    let CityCode = loginlist[0]["CityCode"];
    this.RptFillAlllDDlService.FillAllddl(Ind, OrgCode, CityCode).subscribe(
      (respdata) => {
        if (respdata != "" && respdata.SuccessCD == 1) {
          if (respdata.RespData.Table.length > 0) {
            this.ddlAuctionTypeList = respdata.RespData.Table2;
            this.ddlOfficerList = respdata.RespData.Table4;
            this.ddlZoneList = respdata.RespData.Table5;
            this.ddlAuctionNoList = respdata.RespData.Table6;
            this._filterAuctionList = this.ddlAuctionNoList.slice();
          }
        } else {
          if (respdata != "" && respdata.SuccessCD == 0) {
            this.MsgService.warning(respdata.MsgDesc);
          } else {
            this.MsgService.error("Not Found");
          }
        }
        let Zone = loginlist[0]["ZoneCode"];
        let UserLevelId = loginlist[0]["UserLevelId"];
        if (UserLevelId > 2) {
          this.FrmRptAuction.controls["ddlZone"].setValue(Zone);
          this.FrmRptAuction.controls["ddlZone"].disable();
        } else {
          this.FrmRptAuction.controls["ddlZone"].enable();
        }
      }
    );
  }

  OnAuctionPreview() {
    console.log(this.FrmRptAuction.controls);
    let AuctionNo = this.FrmRptAuction.controls["ddlAuctionNo"].value;
    if (AuctionNo == "") {
      AuctionNo = "0";
    }
    let AuctionType = this.FrmRptAuction.controls["ddlAuctionType"].value;

    let ResponseDecrpt = sessionStorage.getItem("loginSession");
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let OrgCode = loginlist[0]["OrgCode"];
    let CityCode = loginlist[0]["CityCode"];
    let Status = this.FrmRptAuction.controls["ddlStatus"].value;
    let Zone = this.FrmRptAuction.controls["ddlZone"].value;
    // let WinningList = this.winnerListChecked
    // console.log(WinningList)

    this.FromDate = this.FrmRptAuction.controls["txtDateFrom"].value;
    this.ToDate = this.FrmRptAuction.controls["txtDateTo"].value;
    if (this.FromDate == "") {
      {
        this.MsgService.error("Please select the from Date");
        return false;
      }
    }
    if (this.ToDate == "") {
      {
        this.MsgService.error("Please select the To Date ");
        return false;
      }
    }
    if (this.FromDate != "" && this.ToDate != "") {
      if (
        this.FrmRptAuction.controls["txtDateFrom"].value >
        this.FrmRptAuction.controls["txtDateTo"].value
      ) {
        this.MsgService.error("From Date cannot be  greater than  To ");
        return false;
      }
    }

    // var frmdt = $('#txtDateFr').val();

    // var res = frmdt.split('/');
    // this.FromDate = res[2] + '/' + res[1] + '/' + res[0];

    var res = $("#txtDateFr").val().split("/");
    this.FromDate = res[2] + "/" + res[1] + "/" + res[0];

    var restodt = $("#txtDateToo").val().split("/");
    this.ToDate = restodt[2] + "/" + restodt[1] + "/" + restodt[0];
    let Heading = loginlist[0]["ReportHeading"];
    //let Heading = 'Jaipur Municiple Corporation';
    let ReportHeading = "Auction Winner List";
    //localhost:52533/
    //window.open(`http://localhost:61991/RptAuctionWinner.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&AuctionTypecd=` + AuctionType + `&ActiveInd=` + Status +`&Zone=` + Zone +`&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate +`&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptAuctionWinner`);
    //window.open(`http://115.124.113.64/JMCEAuctionReportSource/RptAuctionWinner.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&AuctionTypecd=` + AuctionType + `&ActiveInd=` + Status + `&Zone=` + Zone + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptAuctionWinner`);
    //http://oswalapp.centralindia.cloudapp.azure.com/JMCEAuctionReportViewerSource/
    http: window.open(
      `${Global.Report_base_url}/RptAuctionRefundList.aspx?Ind=1&OrgCode=` +
        OrgCode +
        `&CityCode=` +
        CityCode +
        `&AuctionNo=` +
        AuctionNo +
        `&AuctionTypecd=` +
        AuctionType +
        `&ActiveInd=` +
        Status +
        `&Zone=` +
        Zone +
        `&DateFrom=` +
        this.FromDate +
        `&DateTo=` +
        this.ToDate +
        `&ReportHeading=` +
        ReportHeading +
        `&Heading=` +
        Heading +
        `&ReportName=RptAuctionRefundList`
    );
  }

  OnClear() {
    debugger;

    this.FrmRptAuction.controls["ddlAuctionNo"].setValue("");
    this.FrmRptAuction.controls["ddlStatus"].setValue("2");
    this.FrmRptAuction.controls["ddlAuctionType"].setValue("0");
    this.FrmRptAuction.controls["txtDateFrom"].setValue("");
    this.FrmRptAuction.controls["txtDateTo"].setValue("");
    this.FrmRptAuction.controls["ddlZone"].setValue("0");
    console.log(this.FrmRptAuction.controls);
  }

  onAuctionChange(name: string) {
    this._filterAuctionList = this._myFilter(name);
  }
  private _myFilter(name: string): any[] {
    if (name) {
      return this.ddlAuctionNoList.filter((group) =>
        group.AuctionNo.toLowerCase().includes(name.toLowerCase())
      );
    }
    return this.ddlAuctionNoList;
  }
}
